<template>
  <div class="h-full rounded-lg flex flex-col gap-2">
    <div id="custom-popup" class="popup">
      <div class="popup-content">
        <p>Are you sure you want to continue?</p>
        <button id="confirm-button">Yes</button>
        <button id="cancel-button">No</button>
      </div>
    </div>

    <div class="flex justify-between items-center pb-1 gap-1">
      <div
        v-if="this.validPermission('G0002')"
        class="action_card_div"
        style="display: flex; align-items: center; gap: 1rem"
      >
        <button
          style="background-color: var(--linhaLista)"
          v-if="this.validPermission('G0003')"
          class="btn"
          @click="triggerAction({ action: 'create_artigo' })"
        >
          <i
            class="fa-solid fa-circle-plus fa-2xl"
            style="color: var(--iconCima)"
          ></i>
          <div style="white-space: nowrap; color: var(--label)">
            Novo artigo
          </div>
        </button>

        <button
          style="background-color: var(--linhaLista)"
          v-if="this.validPermission('G0004')"
          class="btn"
          @click="triggerAction({ action: 'transfer_artigo' })"
        >
          <i
            class="fa-solid fa-right-left fa-2xl"
            style="color: var(--iconCima)"
          ></i>
          <!-- <i class="fa-solid fa-table fa-2xl" style="color: var(--iconCima);"></i> -->
          <div style="white-space: nowrap; color: var(--label)">
            Transferir Artigos
          </div>
        </button>

        <button
          style="background-color: var(--linhaLista)"
          v-if="this.validPermission('G0004')"
          class="btn"
          @click="triggerAction({ action: 'transfer_ordemServico' })"
        >
          <i
            class="fa-solid fa-arrows-turn-right fa-2xl"
            style="color: var(--iconCima)"
          ></i>
          <!-- <i class="fa-solid fa-table fa-2xl" style="color: var(--iconCima);"></i> -->
          <div style="white-space: nowrap; color: var(--label)">
            Transferir OrdemServiços
          </div>
        </button>

        <button
          style="background-color: var(--linhaLista)"
          v-if="this.validPermission('G0004')"
          class="btn"
          @click="triggerAction({ action: 'transfer_artigos_viatura' })"
        >
          <i
            class="fa-solid fa-car-side fa-2xl"
            style="color: var(--iconCima)"
          ></i>
          <!-- <i class="fa-solid fa-table fa-2xl" style="color: var(--iconCima);"></i> -->
          <div style="white-space: nowrap; color: var(--label)">
            Transferir Artigos da Viatura
          </div>
        </button>

        <!-- <button style="background-color: var(--linhaLista)"
                v-if="this.validPermission('G0004')" class="btn"
                    @click="triggerAction({ action: 'show_table' })">
                    <i class="fa-solid fa-table fa-2xl" style="color: var(--iconCima);"></i>
                    <div style="white-space: nowrap; color: var(--label)">Listar artigos</div>
                </button> -->

        <!-- <button style="background-color: var(--linhaLista)"
                v-if="this.validPermission('G0005')" class="btn"
                    @click="triggerAction({ action: 'no action' })">
                    <i class="fa-solid fa-newspaper fa-2xl" style="color: var(--iconCima);"></i>
                    <div style="white-space: nowrap; color: var(--label)">Histórico</div>
                </button> -->

        <!-- <button style="background-color: var(--linhaLista)"
                class="btn" @click="triggerAction({ action: 'criar_filtro' })">
                    <i class="fa-solid fa-newspaper fa-2xl" style="color: var(--iconCima);"></i>
                    <div style="white-space: nowrap; color: var(--label)">Criar Filtro</div>
                </button> -->

        <!-- <select v-model="selectedFiltro" id="small"
                class="block w-full p-2 text-sm text-[var(--text)] rounded-lg bg-[var(--linhaLista)] hover:bg-[var(--scroll)] focus:ring-[#a53535] focus:border-[#b44d4d] outline-none"
                >
                    <option value="" disabled>Filtrar</option>
                    <option value="">None</option>
                    <option v-for="(filtro, index) in filtroOptions" :key="index" :value="filtro">
                        {{ filtro.nome }}
                    </option>
                </select> -->

        <!-- <AppActionCard :show="show_action_card" :action_data="action_card_data" @close="close_action_card"
                @action-clicked="triggerAction" /> -->
      </div>
      <!-- <div class="flex justify-end items-center gap-2">
                <AppSearch />
                <AppNotification />
                <AppProfileSearch />
            </div> -->
    </div>
    <!-- <div class="max-w-[100px]">
    </div> -->
    <div
      class="flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema"
    >
      <!-- <AppFilterForm
        :tabela="tabela"
        :visibility="show_form_filter"
        @close="closeFilterForm"
      /> -->
      <div class="flex flex-col md:flex-row gap-2">
        <AppArtigoCreateForm
          :show="show_form"
          :disable_visibility="true"
          :update_visibility="true"
          form_title="Novo Artigo"
          :form_data="artigo_formData"
          :create_btn="create_artigo_"
          :set_data="artigo_setData"
          @triggerAction="triggerAction"
          @close="closeForm"
          @create="create_artigo"
          @update=""
          @block="remove_artigo"
        />

        <ArtigoTransfer
          v-if="show_transfer_form"
          @close="show_transfer_form = false"
        />

        <ArtigoTransferTest
          v-if="show_transfer_test"
          @close="show_transfer_test = false"
        />

        <artigoTransferViatura
          v-if="show_transfer_viatura"
          @close="show_transfer_viatura = false"
        />

        <AppArtigosForm
          :show="show_edit_form"
          :disable_visibility="true"
          :update_visibility="true"
          :form_title="form_title"
          :form_data="artigo_formData"
          :create_btn="create_artigo_"
          :set_data="artigo_setData"
          @close="closeForm"
          @show_table="show_form_table"
          @create=""
          @update="update_artigo"
          @block="remove_artigo"
        />

        <AppTable
          visibility="true"
          :show="show_generic_table"
          :table_data="generic_table_data"
          :table_title="generic_table_title"
          @row-clicked="select_generic_row"
          @close="close_generic_table"
        />
      </div>
      <div class="w-full">
        <!-- <AppTable :visibility="this.validPermission('G0006')" :show="show_table" :table_data="artigos" :table_title="table_title"
                  @row-clicked="select_artigo" @close="close_table" @delete_data="remove_artigo" /> -->
        <!-- <AppTablePagination
          :visibility="this.validPermission('G0006')"
          :show="show_table"
          :table_data="contactos"
          :groupby="{ show: true, field: 'equipamento' }"
          table_title="Artigos"
          @row-clicked="select_artigo"
          @close="close_table"
          @delete_data="remove"
          class="h-full"
          urlString="artigo"
          :refresh="refresh"
          @refreshed="refresh = false"
        /> -->

        <div>
          <GenericDataTable
            v-if="validPermission('G0006')"
            ref="dataTableArtigoRef"
            :key="`artigo-table-${isGroupbyActive}`"
            @row-click="select_artigo"
            :api-url="
              isGroupbyActive
                ? `${baseURl}/api/v1/artigo/pagination/groupby/equipamento/`
                : `${baseURl}/api/v1/artigo/pagination/`
            "
            :useServerSide="true"
            :columns="artigoColumns"
            :preserve-api-order="true"
            :initial-params="currentFilters"
            :show_export="true"
            :show_close_btn="true"
            :show_groupby_btn="true"
            :groupbyActive="isGroupbyActive"
            @toggle-groupby="isGroupbyActive = !isGroupbyActive"
            table_title="Artigos"
            @close="show_artigo_table = false"
            @action="handleArtigoTableAction"
          >
          </GenericDataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppTable from "@/components/tables/table.vue";
import AppInfoCard from "@/components/infoCard.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppButton from "@/components/updated/button.vue";
import AppForm from "@/components/form.vue";
import AppArtigosForm from "@/components/forms/artigo/artigosForm.vue";
import AppFilter from "@/components/filter/filter.vue";
import AppActionCard from "@/components/actionCard.vue";
import AppFilterForm from "@/components/filter/filterForm.vue";
import AppArtigoCreateForm from "@/components/forms/artigo/artigoForm.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import permissionMixin from "@/permissionMixin.js";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import { toast } from "vue3-toastify";
import ArtigoTransfer from "@/components/forms/artigo/artigoTransfer.vue";
import ArtigoTransferTest from "@/components/forms/artigo/ArtigoTransferOrdem.vue";
import artigoTransferViatura from "@/components/forms/artigo/artigoTransferViatura.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";

export default {
  mixins: [permissionMixin],
  name: "appArtigos",
  components: {
    AppTable,
    AppInfoCard,
    AppForm,
    AppFilter,
    AppActionCard,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppArtigosForm,
    AppButton,
    AppFilterForm,
    AppTablePagination,
    AppArtigoCreateForm,
    ArtigoTransfer,
    ArtigoTransferTest,
    artigoTransferViatura,
    GenericDataTable,
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      artigos: [],
      artigo: {},
      artigo_tipos: [],

      show_transfer_form: false,

      refresh: false,

      clientes: [],

      sub_clientes: [],
      locais: [],
      equipamentos: [],
      servicos: [],
      armazens: [],

      generic_table_data: [],

      generic_table_title: "Generic Table",
      current_table: "none",

      show_form: false,
      show_edit_form: false,
      show_table: true,
      show_action_card: true,
      show_generic_table: false,

      form_title: "No Title",

      create_artigo_: false,

      action_card_data: [
        {
          action_name: "Novo artigo",
          action_icon: "fa-solid fa-circle-plus fa-2xl",
          action: "create_artigo",
          visibility: true,
        },
        {
          action_name: "Mostrar Tabela",
          action_icon: "fa-solid fa-table fa-2xl",
          action: "show_table",
          visibility: true,
        },
        {
          action_name: "Histórico",
          action_icon: "fa-solid fa-notes-medical fa-2xl",
          action: "show_table",
          visibility: true,
        },
        {
          action_name: "OK OK",
          action_icon: "fa-solid fa-table fa-2xl",
          action: "show_table",
          visibility: true,
        },
      ],

      filter_data: [
        {
          filter_name: "Dashboard",
          filter_visibility: true,
          filter_selected: true,
        },
        {
          filter_name: "Instalações",
          filter_visibility: true,
          filter_selected: false,
        },
        {
          filter_name: "Preços",
          filter_visibility: true,
          filter_selected: false,
        },
        {
          filter_name: "Empresa",
          filter_visibility: true,
          filter_selected: false,
        },
      ],

      artigo_formData: {},
      artigo_setData: {},

      //   FilterForm data
      filtroData: {},
      show_form_filter: false,
      selectedFiltro: "",
      filtroOptions: [],
      tabela: "artigo",
      table_title: "artigos",

      show_transfer_test: false,
      show_transfer_viatura: false,
      isGroupbyActive: true,
    };
  },
  created() {
    // this.get_artigos();
    // this.getTypes();
    this.setArtigoForm(null);
  },
  computed: {
    artigoColumns() {
      if (this.isGroupbyActive) {
        // Grouped view - show total_artigos
        return [
          {
            key: "equipamento",
            label: "Equipamento",
            type: "string",
            sortable: true,
            maxWidth: 150,
          },
          {
            key: "total_artigos",
            label: "Total de Artigos",
            type: "number",
            sortable: true,
            maxWidth: 150,
          },
          {
            key: "status",
            label: "Status",
            type: "string",
            sortable: true,
            maxWidth: 100,
          },
        ];
      } else {
        // Ungrouped view - show individual artigo details
        return [
          {
            key: "codigoBarra",
            label: "Código de Barra",
            type: "string",
            sortable: true,
            maxWidth: 110,
          },
          {
            key: "equipamento.nome",
            label: "Equipamento",
            type: "string",
            sortable: true,
            maxWidth: 250,
          },
          {
            key: "precoVenda",
            label: "Preço de Venda",
            type: "currency",
            sortable: true,
            maxWidth: 100,
          },
          {
            key: "precoVenda",
            label: "Preço de Venda",
            type: "currency",
            sortable: true,
            maxWidth: 100,
          },
          {
            key: "fornecedor.nome",
            label: "Fornecedor",
            type: "string",
            sortable: true,
            maxWidth: 100,
          },
         
          {
            key: "status",
            label: "Status",
            type: "string",
            sortable: true,
            maxWidth: 90,
          },
        ];
      }
    },
  },
  methods: {
    async get_artigos() {
      const res = await this.select_all(`${this.baseURl}/api/v1/artigo/`);
      console.log("artigos:", res);

      // console.log("modified_artigos:", modified_artigos);
      this.artigos = res?.sort((a, b) => a.id - b.id);
    },
    async create_artigo(data) {
      console.log("view create_form_data:", data);

      let create_data = this.setData(data);
      console.log("artigo to create", create_data);

      const res = await this.create(
        create_data,
        `${this.baseURl}/api/v1/artigo/quantity/registrar/`,
      );
      console.log("response:", res);
      if (res) {
        toast.success("fornecedor criado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.closeForm();
        // await this.get_artigos();
        await this.getTypes();
        this.refresh = true;
        this.show_table = true;
      } else {
        toast.error("Erro ao criar fornecedor", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },

    async select_artigo(data) {
      this.close_generic_table();
      this.create_artigo_ = false;
      this.form_title = "Informação Do artigo";
      if (this.isGroupbyActive){
         toast.warning("Selecione um artigo individual para ver os detalhes.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        return;
      }
      const artigo = await this.select(
        `${this.baseURl}/api/v1/artigo/${data.id}/`,
      );

      this.setArtigoForm(artigo);
      this.show_form = false;
      this.show_edit_form = true;
      this.show_transfer_form = false;
    },

    async update_artigo(data) {
      console.log("artigo to update:", data);

      let update_data = this.setData(data);
      console.log("artigo ready to update", update_data);

      const res = await this.update(
        `${this.baseURl}/api/v1/artigo/editar/${data.id}/`,
        update_data,
      );
      console.log("response:", res);
      // await this.get_artigos();
      await this.getTypes();
      this.show_table = true;
    },
    async remove_artigo(data) {
      console.log("artigo to remove:", data);
      const res = await this.remove(
        `${this.baseURl}/api/v1/artigo/eliminar/${data.id}/`,
      );
      if (res) {
        this.close_generic_table();
        this.closeForm();
      }
      // await this.get_artigos();
    },

    closeForm() {
      this.show_form = false;
      this.show_edit_form = false;
      this.close_generic_table();
    },

    close_table() {
      this.show_table = false;
    },
    close_generic_table() {
      if (this.show_generic_table) {
        //this.show_generic_table=false;
        document.getElementById("right_form").style.display = "flex";
      }

      this.show_generic_table = false;
    },

    close_action_card() {
      this.show_action_card = false;
    },
    closeFilterForm() {
      this.show_form_filter = false;
    },
    triggerAction(action) {
      console.log("action to perform:", action);
      if (action.action === "create_artigo") {
        this.close_all();
        this.create_artigo_ = true;
        this.form_title = "Criar artigo";
        this.setArtigoForm(null);
        this.show_form = true;
        this.show_edit_form = false;
        this.close_generic_table();
        console.log("show ", this.show_form);
      }
      if (action.action === "show_table") {
        this.show_table = true;
      }

      if (action.action === "transfer_artigo") {
        this.close_all();
        this.show_transfer_form = true;

        //this.show_transfer_test = false;
      }
      if (action.action === "criar_filtro") {
        this.close_all();
        this.show_form_filter = true;
      }
      if (action.action === "transfer_ordemServico") {
        this.close_all();
        this.show_transfer_test = true;
        //this.show_edit_form = false;
        //this.show_transfer_form = false;
      }

      if (action.action === "transfer_artigos_viatura") {
        this.close_all();
        this.show_transfer_viatura = true;
      }
    },
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return true;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },
    async getTypes() {
      //   const tipos = await this.select_all(`${this.baseURl}/api/v1/tpartigo/`);
      //   const armazens = await this.select_all(`${this.baseURl}/api/v1/armazem/`)
      //   const clientes = await this.select_all(`${this.baseURl}/api/v1/cliente/`);
      //   //const GPS = await this.select_all(` ${this.baseURl}/api/v1/GPS/`);
      //   //const sub_clientes = await this.select_all(`${this.baseURl}/api/v1/cliente/`);
      //   //const equipamentos = await this.select_all(`${this.baseURl}/api/v1/equipamento/`);
      //   //const servicos = await this.select_all(`${this.baseURl}/api/v1/servico/`);
      //   //const locais = await this.select_all(`${this.baseURl}/api/v1/local/`);
      //   this.artigo_tipos = tipos?.sort((a, b) => a.id - b.id);
      //   this.armazens = armazens?.sort((a, b) => a.id - b.id);
      //   this.clientes = clientes?.sort((a, b) => a.id - b.id);
      //   this.sub_clientes = sub_clientes?.sort((a, b) => a.id - b.id);
      //   this.equipamentos = equipamentos?.sort((a, b) => a.id - b.id);
      //   this.servicos = servicos?.sort((a, b) => a.id - b.id);
      //   this.locais = locais?.sort((a, b) => a.id - b.id);
      //   console.log("form_data:", this.artigo_formData)
    },

    setArtigoForm(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      this.artigo_formData = {
        id: data && data.id ? data.id : 0,
        numero: data && data.numeroSerie ? data.numeroSerie : "",
        quantidade: data && data.quantidade ? data.quantidade : 1,
        dataFabrico: data && data.dataFabrico ? data.dataFabrico : "2025-01-01",
      };

      this.artigo_setData = {
        armazem:
          data && data.armazem && !isEmptyObject(data?.armazem)
            ? data.armazem
            : { id: 0, nome: "N/A" },
        equipamento:
          data && data.equipamento && !isEmptyObject(data?.equipamento)
            ? data.equipamento
            : { id: 0, nome: "N/A" },
        tipo_artigo:
          data && data.tpArtigo && !isEmptyObject(data?.tpArtigo)
            ? data.tpArtigo
            : { id: 0, nome: "N/A" },
        cliente:
          data && data.fornecedor && !isEmptyObject(data?.fornecedor)
            ? data.fornecedor
            : { id: 0, nome: "N/A" },
        sub_cliente:
          data && data.sub_cliente && !isEmptyObject(data?.sub_cliente)
            ? data.sub_cliente
            : { id: 0, nome: "N/A" },
        local:
          data && data.local && !isEmptyObject(data?.local)
            ? data.local
            : { id: 0, nome: "N/A" },
        servico:
          data && data.servico && !isEmptyObject(data?.servico)
            ? data.servico
            : { id: 0, nome: "N/A" },
      };
    },

    setData(data) {
      let prepared_data = {
        numeroSerie: data.numero || "",
        dataFabrico: data.dataFabrico || "",
        armazem_id: data?.armazem?.id || 0,
        quantidade: data.quantidade || 1,
        equipamento_id: data?.equipamento?.id || 0,
        codigoBarra: 0,
        tpArtigo_id: 0,
        fornecedor_id: 0,
        precoCompra: 0,
        precoVenda: 0,
      };
      return prepared_data;
    },

    show_form_table(data) {
      const tableMappings = {
        tipo: { data: this.tipos, title: "Tipos" },
        armazem: { data: this.utilizadores, title: "Armazens" },
        cliente: { data: this.clientes, title: "Clientes" },
        sub_cliente: { data: this.artigos, title: "Sub_Clientes" },
        local: { data: this.locais, title: "Locais" },
        equipamento: { data: this.equipamentos, title: "Equipamentos" },
        servico: { data: this.servicos, title: "Serviços" },
      };

      const mapping = tableMappings[data];
      if (mapping) {
        this.current_table = data;
        this.generic_table_data = mapping.data;
        this.generic_table_title = mapping.title;
        this.show_generic_table = true;

        document.getElementById("right_form").style.display = "none";
      }
    },

    select_generic_row(data) {
      console.log("row selected:", data);
      console.log("current_table:", this.current_table);

      const tableMapping = {
        tipo: "tipo_artigo",
        armazem: "armazem",
        cliente: "cliente",
        subcliente: "sub_cliente",
        local: "local",
        equipamento: "equipamento",
        servico: "servico",
      };

      if (tableMapping[this.current_table]) {
        this.artigo_setData[tableMapping[this.current_table]] = data;
      }
    },
    close_all() {
      this.show_edit_form = false;
      this.show_transfer_form = false;
      this.show_transfer_test = false;
      this.show_transfer_viatura = false;
      this.show_form = false;
    },
  },
  watch: {
    async selectedFiltro(newFiltro) {
      if (newFiltro) {
        this.filtroData = { ...newFiltro };
        delete this.filtroData.id;
        delete this.filtroData.status;
        this.show_table = true;
        this.table_title =
          this.filtroData.nome.charAt(0).toUpperCase() +
          this.filtroData.nome.slice(1).toLowerCase();
        const response = await axios.post(
          `${this.baseURl}/api/v1/filtro/testar/`,
          this.filtroData,
        );
        this.artigos = response.data.data;
        console.log(this.artigos);
      } else {
        // this.get_artigos();
        this.table_title = "artigos";
        this.show_table = true;
      }
    },
  },
};
</script>

<style>
.scroll-style {
  overflow-y: auto;
  scrollbar-color: gray transparent;
  scrollbar-width: thin;
}

.popup {
  position: fixed;
  display: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid black;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.popup-content {
  text-align: center;
}

.popup button {
  margin: 0 10px;
  padding: 5px 10px;
  cursor: pointer;
}

.btn {
  font-size: 12px;
  width: fit-content;
  padding: 0.5rem 0.8rem;
  color: white;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #626288;
}

.btn:hover {
  background-color: #c67700;
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
